// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.deliveryTerms', {
    url: '/deliveryterms',
    templateUrl: 'main/configuration/deliveryTerms/deliveryTerms.tpl.html',
    data: { pageTitle: 'Delivery terms' },
  });
};

angular.module('configuration.deliveryTerms', []).config(config);
